import * as Preact from 'preact';
import { Product } from '../data/product';
import * as Furniture from '../data/furniture';
import { Price } from '@dora/backpack';
import * as O from 'fp-ts/Option';
import * as Selectors from '../store/selectors';
import { useSelector } from './hooks/redux';
import { CheckoutItemGroup, CheckoutEmptyGroup } from '@dora/components';
import * as Summary from '../data/summary';
import * as Pr from '../data/product';
import { pipe } from 'fp-ts/lib/function';
import { identity } from 'fp-ts/lib/function';

function furnitureListCompare(a: Furniture.FurnitureItem, b: Furniture.FurnitureItem): number {
    return O.isSome(a.configuration) != O.isSome(b.configuration)
        ? O.isSome(a.configuration)
            ? -1
            : 1
        : Summary.getName(a.summary) < Summary.getName(b.summary) ||
          (Summary.equalsByName(a.summary, b.summary) && a.aryaId < b.aryaId)
        ? -1
        : 1;
}

export type Props = {
    items: Array<Furniture.FurnitureItem>;
    bundles: Array<Furniture.Bundle>;
    singleItemsPrice: number;
    originalTotal: number;
    products: Array<Product>;
    onAddClick: () => void;
};

export const Component = (props: Props) => {
    const productBySku = useSelector(Selectors.ProductData.productBySkuFn);

    const locale = useSelector(Selectors.Core.locale);
    const currency = useSelector(Selectors.Core.currency);

    return (
        <>
            {!props.bundles.length && !props.items.length ? (
                <CheckoutEmptyGroup.Component
                    onAddClick={props.onAddClick}
                    price={Price.toLocaleString(0, locale, currency)}
                />
            ) : (
                <>
                    {props.bundles.length > 0 &&
                        props.bundles.map(bundle => {
                            return (
                                <CheckoutItemGroup.Component
                                    subheader={pipe(
                                        // TODO: This isn't great - this shouldn't be sitting out in the middle of a compenent
                                        // should be able to handle all this potential nullness with dataTypes.
                                        O.fromNullable(productBySku),
                                        O.ap(O.fromNullable(bundle.canonicalId)),
                                        O.chain(O.fromNullable),
                                        O.map(Pr.summaryName),
                                        O.fold(() => bundle.canonicalId, identity),
                                    )}
                                    price={Price.toLocaleString(bundle.price, locale, currency)}
                                    originalPrice={Price.toLocaleString(
                                        Furniture.getOriginalBundlePrice(bundle),
                                        locale,
                                        currency,
                                    )}
                                    items={bundle.items.sort(furnitureListCompare).map(item => {
                                        return {
                                            imageUrl: Summary.getImage(item.summary),
                                            productName: Summary.getName(item.summary),
                                        };
                                    })}
                                />
                            );
                        })}
                    {props.items.length > 0 && (
                        <CheckoutItemGroup.Component
                            subheader="Single Items"
                            price={Price.toLocaleString(props.singleItemsPrice, locale, currency)}
                            items={props.items.sort(furnitureListCompare).map(item => {
                                return {
                                    imageUrl: Summary.getImage(item.summary),
                                    productName: Summary.getName(item.summary),
                                    productPrice: Price.toLocaleString(
                                        Furniture.furniturePrice(item),
                                        locale,
                                        currency,
                                    ),
                                };
                            })}
                        />
                    )}
                </>
            )}
        </>
    );
};
